import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "size", "children", "beforeIcon", "fullWidth"];
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import cx from 'classnames';
import { getTheme } from '../../themes';
import * as styles from '../../styles/shared.css';
import * as customStyles from '../../styles/linkButton.css';

/**
 * Компонент ссылки, визуально неотличимый от кнопки
 * Имеет настройки тем, размеров. Умеет отображать иконку и текст
 * встроен rel="noopener" для обеспечения безопасности (nofollow и noreferrer не включены по причинам SEO и аналитики)
 */
var LinkButtonComponent = /*#__PURE__*/React.forwardRef(function LinkButton(props, ref) {
  var theme = props.theme,
    size = props.size,
    children = props.children,
    beforeIcon = props.beforeIcon,
    fullWidth = props.fullWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var themeClasses = getTheme(theme);
  var containerClasses = cx(styles['button'], customStyles['link-button'], styles[size], themeClasses['button'], _defineProperty({}, styles['full-width'], fullWidth));
  return /*#__PURE__*/React.createElement("a", _extends({
    className: containerClasses,
    rel: "noopener"
  }, rest, {
    ref: ref
  }), beforeIcon, children && /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, children));
});
LinkButtonComponent.defaultProps = {
  theme: 'fill_primary',
  size: 'M'
};
export var LinkButton = /*#__PURE__*/React.memo(LinkButtonComponent);